import { AxiosResponse } from 'axios';
import { useCallback, useEffect, useState } from 'react';

import { useApi } from '@/hooks/api';

export interface GuestPassData {
	valid: boolean;
	sender_name: string;
	trial_length: number;
}

export interface ValidateGuestPassApiResponse {
	data: GuestPassData | null;
	error: Error | null;
	loading: boolean;
}

export const useGuestPass = (code: string | undefined): ValidateGuestPassApiResponse => {
	const [data, setData] = useState<GuestPassData | null>(null);
	const [error, setError] = useState<Error | null>(null);
	const [loading, setLoading] = useState<boolean>(false);

	const apiRequest = useApi();
	const endpoint = 'guest-pass/validate';

	const validateGuestPass = useCallback(async () => {
		setLoading(true);
		try {
			const response: AxiosResponse = await apiRequest({
				endpoint,
				method: 'POST',
				body: { code },
			});
			setData(response.data);
		} catch (err) {
			throw new Error('Not able to validate guest pass code');
		} finally {
			setLoading(false);
		}
	}, [apiRequest, code]);

	useEffect(() => {
		if (code && typeof code === 'string') {
			validateGuestPass().catch(err => {
				setError(err);
			});
		}
	}, [code, validateGuestPass]);

	return { data, error, loading };
};
